module.exports = __webpack_public_path__ + "img/grey-mic.7f730e1d.svg";